export const SFRTA_DefectDetectorTestsAndInspectionsReportContents = {
  TrackSection: {
    heights: {
      header1: "auto",
    },
    inlineData: true,
    classes: {
      header1: "grey-background",
    },
    columns: [
      {
        title: "Track",
        colSpan: 20,
        rowSpan: 1,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: 'track'
      },
    ],
  },
  DraggingEquipmentTitle: {
    heights: {
      header1: "50px",
    },
    headerOnly: true,
    columns: [
      {
        title: "Dragging Equipment",
        colSpan: 20,
        rowSpan: 1,
        className: "tbl-text-normal text-left pd-left-10px d-block",
      },
    ],
  },
  HBDTitle: {
    heights: {
      header1: "50px",
    },
    headerOnly: true,
    columns: [
      {
        title: "Hot Box Detector",
        colSpan: 20,
        rowSpan: 1,
        className: "tbl-text-normal text-left pd-left-10px d-block",
      },
    ],
  },
  _30d: {
    heights: {
      header1: "auto",
    },
    headerOnly: true,
    columns: [
      {
        title: "30d",
        colSpan: 20,
        rowSpan: 1,
        className: "tbl-text-normal",
      },
    ],
  },
  _90d: {
    heights: {
      header1: "auto",
    },
    headerOnly: true,
    columns: [
      {
        title: "90d",
        colSpan: 20,
        rowSpan: 1,
        className: "tbl-text-normal",
      },
    ],
  },
  TestCasesTable: {
    heights: {
      header1: "auto",
    },
    classes: {
      header1: 'display-none'
    },
    minDataRowsCount: 1,
    columns: [
      {
        title: "Description",
        colSpan: 15,
        rowSpan: 1,
        className: "tbl-text-normal",
        accessor:  "description",
        dataClassName: "text-left pd-left-10px d-block"
      },
      {
        title: "Status",
        colSpan: 5,
        rowSpan: 1,
        className: "tbl-text-normal",
        accessor: "status",
        dataClassName: "text-right pd-right-10px d-block"
      },
    ],
  },
  rowDataSequence: {
    sfrtaDraggingEquip30Days: [
      'Inspect dragging equipment',
      'Test operation of dragging equipment'
    ],
    sfrtaHotBox30Days: [
      'Clean lens & mirror',
      'Inspect transducers',
      'Inspect scanners',
      'Check track conditions',
      'Verify time, date, & setup',
      'Compare R1 & R2 Ave.',
      'Verify alarms',
      'Check recall',
      'Check battery voltage',
      'Verify Train Direction'
    ],
    sfrtaHotBox90Days: [
      'Test modem',
      'Turn off battery charger',
      'Check alignment',
      'Check transducer loading',
      'Check transducer polarity',
      'Verify ambient temperature reading',
      "Calibrate scanners",
      'Check integrity heat',
      'Check case heaters',
      'Verify alarm readout',
      'Verify alarm settings',
      'Verify version of software',
      'Turn on battery charger'
    ]
  }
}



// WEBPACK FOOTER //
// ./src/components/Reports/SFRTA/DefectDetectorTestsAndInspectionsReport/SFRTA_DefectDetectorTestsAndInspectionsReportSchema.js